import axios from 'axios';
import config from '../../config';
import { getUserToken } from '../../utils/helpers';

export const GET_FOLDERS = 'GET_FOLDERS';
export const GET_FOLDERS_SUCCESS = 'GET_FOLDERS_SUCCESS';
export const GET_FOLDERS_FAIL = 'GET_FOLDERS_FAIL';
export const GET_FOLDERS_RESET = 'GET_FOLDERS_RESET';

export const CREATE_FOLDER = 'CREATE_FOLDER';
export const CREATE_FOLDER_SUCCESS = 'CREATE_FOLDER_SUCCESS';
export const CREATE_FOLDER_FAIL = 'CREATE_FOLDER_FAIL';
export const CREATE_FOLDER_RESET = 'CREATE_FOLDER_RESET';

export const RENAME_FOLDER = 'RENAME_FOLDER';
export const RENAME_FOLDER_SUCCESS = 'RENAME_FOLDER_SUCCESS';
export const RENAME_FOLDER_FAIL = 'RENAME_FOLDER_FAIL';
export const RENAME_FOLDER_RESET = 'RENAME_FOLDER_RESET';

export const DELETE_FOLDER = 'DELETE_FOLDER';
export const DELETE_FOLDER_SUCCESS = 'DELETE_FOLDER_SUCCESS';
export const DELETE_FOLDER_FAIL = 'DELETE_FOLDER_FAIL';
export const DELETE_FOLDER_RESET = 'DELETE_FOLDER_RESET';

export const ADD_ITEM_TO_FOLDER = 'ADD_ITEM_TO_FOLDER';
export const ADD_ITEM_TO_FOLDER_SUCCESS = 'ADD_ITEM_TO_FOLDER_SUCCESS';
export const ADD_ITEM_TO_FOLDER_FAIL = 'ADD_ITEM_TO_FOLDER_FAIL';
export const ADD_ITEM_TO_FOLDER_RESET = 'ADD_ITEM_TO_FOLDER_RESET';

export const REMOVE_ITEM_FROM_FOLDER = 'REMOVE_ITEM_FROM_FOLDER';
export const REMOVE_ITEM_FROM_FOLDER_SUCCESS = 'REMOVE_ITEM_FROM_FOLDER_SUCCESS';
export const REMOVE_ITEM_FROM_FOLDER_FAIL = 'REMOVE_ITEM_FROM_FOLDER_FAIL';
export const REMOVE_ITEM_FROM_FOLDER_RESET = 'REMOVE_ITEM_FROM_FOLDER_RESET';

// Action creators
export const getFolders = () => ({ type: GET_FOLDERS });
export const getFoldersSuccess = (response) => ({ type: GET_FOLDERS_SUCCESS, response });
export const getFoldersFail = (response) => ({ type: GET_FOLDERS_FAIL, response });
export const getFoldersReset = () => ({ type: GET_FOLDERS_RESET });

export const createFolder = () => ({ type: CREATE_FOLDER });
export const createFolderSuccess = (response) => ({ type: CREATE_FOLDER_SUCCESS, response });
export const createFolderFail = (response) => ({ type: CREATE_FOLDER_FAIL, response });
export const createFolderReset = () => ({ type: CREATE_FOLDER_RESET });

export const renameFolder = () => ({ type: RENAME_FOLDER });
export const renameFolderSuccess = (response) => ({ type: RENAME_FOLDER_SUCCESS, response });
export const renameFolderFail = (response) => ({ type: RENAME_FOLDER_FAIL, response });
export const renameFolderReset = () => ({ type: RENAME_FOLDER_RESET });

export const deleteFolder = () => ({ type: DELETE_FOLDER });
export const deleteFolderSuccess = (response) => ({ type: DELETE_FOLDER_SUCCESS, response });
export const deleteFolderFail = (response) => ({ type: DELETE_FOLDER_FAIL, response });
export const deleteFolderReset = () => ({ type: DELETE_FOLDER_RESET });

export const addItemToFolder = () => ({ type: ADD_ITEM_TO_FOLDER });
export const addItemToFolderSuccess = (response) => ({ type: ADD_ITEM_TO_FOLDER_SUCCESS, response });
export const addItemToFolderFail = (response) => ({ type: ADD_ITEM_TO_FOLDER_FAIL, response });
export const addItemToFolderReset = () => ({ type: ADD_ITEM_TO_FOLDER_RESET });

export const removeItemFromFolder = () => ({ type: REMOVE_ITEM_FROM_FOLDER });
export const removeItemFromFolderSuccess = (response) => ({ type: REMOVE_ITEM_FROM_FOLDER_SUCCESS, response });
export const removeItemFromFolderFail = (response) => ({ type: REMOVE_ITEM_FROM_FOLDER_FAIL, response });
export const removeItemFromFolderReset = () => ({ type: REMOVE_ITEM_FROM_FOLDER_RESET });

// Thunk API calls
export const getFoldersApi = (entityType = 'project') => {
  return (dispatch) => {
    dispatch(getFolders());
    axios
      .get(`${config.api.base_url}/folders`, {
        params: { entity_type: entityType },
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch(getFoldersSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getFoldersFail(error.response?.data || error.message));
      });
  };
};

export const createFolderApi = (data) => {
  return (dispatch) => {
    dispatch(createFolder());
    axios
      .post(`${config.api.base_url}/folders`, data, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch(createFolderSuccess(response.data));
      })
      .catch((error) => {
        dispatch(createFolderFail(error.response?.data || error.message));
      });
  };
};

export const renameFolderApi = (id, data) => {
  return (dispatch) => {
    dispatch(renameFolder());
    axios
      .put(`${config.api.base_url}/folders/${id}`, data, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch(renameFolderSuccess(response.data));
      })
      .catch((error) => {
        dispatch(renameFolderFail(error.response?.data || error.message));
      });
  };
};

export const deleteFolderApi = (id) => {
  return (dispatch) => {
    dispatch(deleteFolder());
    axios
      .delete(`${config.api.base_url}/folders/${id}`, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch(deleteFolderSuccess(response.data));
      })
      .catch((error) => {
        dispatch(deleteFolderFail(error.response?.data || error.message));
      });
  };
};

export const addItemToFolderApi = (folderId, itemId) => {
  return (dispatch) => {
    dispatch(addItemToFolder());
    axios
      .post(
        `${config.api.base_url}/folders/${folderId}/add-item`,
        { itemId },
        {
          headers: {
            Authorization: 'Bearer ' + getUserToken(),
          },
        }
      )
      .then((response) => {
        dispatch(addItemToFolderSuccess(response.data));
      })
      .catch((error) => {
        dispatch(addItemToFolderFail(error.response?.data || error.message));
      });
  };
};

export const removeItemFromFolderApi = (folderId, itemId) => {
  return (dispatch) => {
    dispatch(removeItemFromFolder());
    axios
      .post(
        `${config.api.base_url}/folders/${folderId}/remove-item`,
        { itemId },
        {
          headers: {
            Authorization: 'Bearer ' + getUserToken(),
          },
        }
      )
      .then((response) => {
        dispatch(removeItemFromFolderSuccess(response.data));
      })
      .catch((error) => {
        dispatch(removeItemFromFolderFail(error.response?.data || error.message));
      });
  };
};
